export default {
  id: "df11f267-0d8f-420d-a7ca-337f96debc24",
  analyticTitle: "Transfer a prepaid number Landing page",
  sections: [
    {
      type: "paragraph_list",
      id: "18afbbf4-78a0-4b57-a74e-dde52e4c82c5",
      analyticTitle: "Transfer a prepaid number page",
      title: "Transfer a prepaid number",
      siteType: "CBU",
      description:
        "<p>If you have an existing prepaid cellphone number (from any SA network) that you would like to use on this contract, you can apply to have it transferred now. If not, you can skip this step.</p>",
      headingTitle: "Which number would you like to use?",
      items: [
        {
          id: "c8466536-2877-4e47-943d-d643aef39828",
          icon: "https://wwwqa.vodacom.co.za/sites/vodacomcoza/files/2021-10/plus_icon.svg",
          title: "I’d like a new number",
        },
        {
          id: "12452fe2-8c99-46f9-b1a7-8fa10ee72589",
          icon: "https://wwwqa.vodacom.co.za/sites/vodacomcoza/files/2021-10/logo_icon.svg",
          title: "I have a Vodacom  prepaid number",
        },
        {
          id: "9daf401d-ea58-483a-bc98-ae511078a54f",
          icon: "https://wwwqa.vodacom.co.za/sites/vodacomcoza/files/2021-10/transfer_icon.svg",
          title: "I have a prepaid number from another network",
        },
      ],
    },
    {
      type: "paragraph_list",
      id: "b37336a5-d6c3-4d9a-9063-fc122db7d713",
      analyticTitle: "I have a prepaid number from another network page",
      title: "Important things to know:",
      siteType: "CBU",
      items: [
        {
          id: "7c6e4f0a-2f32-40dd-8ed6-3f541a869f75",
          description:
            "<ul>\t<li>We can transfer a number from any network, as long as it’s a prepaid number.</li>\t<li>If your number could not be transferred successfully, you will automatically be assigned a new number.</li>\t<li>Any airtime and/or bundles loaded on your number will be forfeited when you start using your new SIM card.</li>\t<li>We can’t transfer a number that has been transferred (ported) to another network in the last 60 days.</li></ul>",
        },
      ],
    },
    {
      type: "paragraph_list",
      id: "6ddeb11d-3574-4bc4-857d-fa4fab223f12",
      analyticTitle: "Transfer number checkout",
      siteType: "CBU",
      items: [
        {
          id: "8652d5c6-2726-4145-b5f5-8536b8621594",
          description:
            "<p>I agree that the number above is a prepaid number and it belongs to me</p>",
        },
        {
          id: "9c0fd2dc-115b-44f6-ae58-fcf59d10a8ca",
          description:
            "<p>I agree to receive a new number if this number cannot be transferred successfully</p>",
        },
        {
          id: "e5b77895-255e-4b59-972c-f5dbb77c30a8",
          description:
            "<p>I agree to forfeit any airtime or bundles on this number when it is transferred</p>",
        },
      ],
    },
  ],
  status: "success",
};
